module.exports = __webpack_public_path__ + "media/svg/ax-310c28a9.svg";